import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PolicyDocumentSyncService {
  public apiUrl = 'policy-document-sync';

  constructor(private readonly http: HttpClientService) {}

  public sync(programRoleId: string, eidToken: string): Observable<void> {
    const options = {
      headers: new HttpHeaders({
        'X-Eid-Token': eidToken
      })
    };
    return this.http.post<void>(`${this.apiUrl}/${programRoleId}`, null, options);
  }
}
